import { useEffect, useRef } from 'react';

export default function useWakeLock() {
  const wakeLockRef = useRef(null);

  const requestWakeLock = async () => {
    try {
      if ('wakeLock' in navigator) {
        wakeLockRef.current = await navigator.wakeLock.request('screen');
        console.log('✅ Wake Lock acquired');
        wakeLockRef.current.addEventListener('release', () => {
          console.log('🛌 Wake Lock was released');
        });
      } else {
        console.warn('❌ Wake Lock API not supported in this browser.');
      }
    } catch (err) {
      console.error('❌ Failed to obtain Wake Lock:', err);
    }
  };

  useEffect(() => {
    // Try on load
    requestWakeLock();

    // Try again when tab becomes visible
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        requestWakeLock();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    // ALSO: Add user interaction to retry
    document.addEventListener('click', requestWakeLock);
    document.addEventListener('touchstart', requestWakeLock);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      document.removeEventListener('click', requestWakeLock);
      document.removeEventListener('touchstart', requestWakeLock);
      if (wakeLockRef.current) {
        wakeLockRef.current.release();
      }
    };
  }, []);
}
